import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

interface CreateApplicationParams {
  concerns?: string[];
  insuranceStatus?: string;
  hikingPlanStatus?: string;
  comment?: string;
}

const approveApplicationFn = httpsCallable<{ applicationId: string }, { ok: boolean }>(
  functions, 'approveApplication'
);
const rejectApplicationFn = httpsCallable<{ applicationId: string }, { ok: boolean }>(
  functions, 'rejectApplication'
);
const cancelApplicationFn = httpsCallable<{ applicationId: string }, { ok: boolean }>(
  functions, 'cancelApplication'
);
const createApplicationFn = httpsCallable<
  { recruitmentId: string; preHikeSurvey: CreateApplicationParams },
  { success?: boolean; applicationId?: string }
>(functions, 'createApplication');
const unapproveApplicationFn = httpsCallable<{ applicationId: string }, { success: boolean }>(
  functions, 'unapproveApplication'
);
const unrejectApplicationFn = httpsCallable<{ applicationId: string }, { success: boolean }>(
  functions, 'unrejectApplication'
);

export const applicationService = {
  create(
    recruitmentId: string,
    preHikeSurvey: CreateApplicationParams = {}
  ): ReturnType<typeof createApplicationFn> {
    return createApplicationFn({ recruitmentId, preHikeSurvey });
  },

  approve(applicationId: string): ReturnType<typeof approveApplicationFn> {
    return approveApplicationFn({ applicationId });
  },

  reject(applicationId: string): ReturnType<typeof rejectApplicationFn> {
    return rejectApplicationFn({ applicationId });
  },

  cancel(applicationId: string): ReturnType<typeof cancelApplicationFn> {
    return cancelApplicationFn({ applicationId });
  },

  unApprove(applicationId: string): ReturnType<typeof unapproveApplicationFn> {
    return unapproveApplicationFn({ applicationId });
  },

  unReject(applicationId: string): ReturnType<typeof unrejectApplicationFn> {
    return unrejectApplicationFn({ applicationId });
  },
};
